/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件工具自动生成，请勿直接修改！！！ */

// @ts-ignore

import request from '@/utils/request/index';
/**
 * 接口 [客户批量打标↗](https://yapi.fenxianglife.com/project/379/interface/api/44566) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/tag/batch/add`
 * @更新时间 `2024-04-17 15:56:30`
 */
export const feimaChatCustomerTagBatchAdd = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerTagBatchAddRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatCustomerTagBatchAddResponse, OT>
  >('/customer/tag/batch/add', 'POST', data, options);

/**
 * 接口 [客户对话列表↗](https://yapi.fenxianglife.com/project/379/interface/api/44596) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/conversation`
 * @更新时间 `2023-10-09 19:44:39`
 */
export const feimaChatCustomerConversation = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerConversationRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatCustomerConversationResponse, OT>
  >('/customer/conversation', 'POST', data, options);

/**
 * 接口 [客户数量列表↗](https://yapi.fenxianglife.com/project/379/interface/api/44698) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `GET /customer/count/list`
 * @更新时间 `2023-10-16 18:57:32`
 */
export const feimaChatCustomerCountList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerCountListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatCustomerCountListResponse, OT>
  >('/customer/count/list', 'GET', data, options);

/**
 * 接口 [客户分组列表-客户群聊列表\/客户标签列表↗](https://yapi.fenxianglife.com/project/379/interface/api/44704) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `GET /customer/plat/group/list`
 * @更新时间 `2023-10-13 15:26:50`
 */
export const feimaChatCustomerPlatGroupList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerPlatGroupListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatCustomerPlatGroupListResponse, OT>
  >('/customer/plat/group/list', 'GET', data, options);

/**
 * 接口 [客户详情↗](https://yapi.fenxianglife.com/project/379/interface/api/44710) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `GET /customer/detail`
 * @更新时间 `2023-10-13 15:54:29`
 */
export const feimaChatCustomerDetail = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerDetailRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatCustomerDetailResponse, OT>>(
    '/customer/detail',
    'GET',
    data,
    options
  );

/**
 * 接口 [客户列表↗](https://yapi.fenxianglife.com/project/379/interface/api/44728) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/list`
 * @更新时间 `2023-10-30 17:36:38`
 */
export const feimaChatCustomerList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerListRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatCustomerListResponse, OT>>(
    '/customer/list',
    'POST',
    data,
    options
  );

/**
 * 接口 [客户数据统计↗](https://yapi.fenxianglife.com/project/379/interface/api/44764) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `GET /customer/data/statistics`
 * @更新时间 `2023-10-13 09:59:26`
 */
export const feimaChatCustomerDataStatistics = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerDataStatisticsRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatCustomerDataStatisticsResponse, OT>
  >('/customer/data/statistics', 'GET', data, options);

/**
 * 接口 [客户打标↗](https://yapi.fenxianglife.com/project/379/interface/api/44806) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/tag/add`
 * @更新时间 `2023-10-13 15:29:25`
 */
export const feimaChatCustomerTagAdd = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerTagAddRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatCustomerTagAddResponse, OT>>(
    '/customer/tag/add',
    'POST',
    data,
    options
  );

/**
 * 接口 [客户来源群↗](https://yapi.fenxianglife.com/project/379/interface/api/44818) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/source/group`
 * @更新时间 `2023-10-13 15:48:11`
 */
export const feimaChatCustomerSourceGroup = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerSourceGroupRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatCustomerSourceGroupResponse, OT>
  >('/customer/source/group', 'POST', data, options);

/**
 * 接口 [客户已打标签↗](https://yapi.fenxianglife.com/project/379/interface/api/44824) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/tag`
 * @更新时间 `2023-10-13 16:50:26`
 */
export const feimaChatCustomerTag = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerTagRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatCustomerTagResponse, OT>>(
    '/customer/tag',
    'POST',
    data,
    options
  );

/**
 * 接口 [修改客户对话配置↗](https://yapi.fenxianglife.com/project/379/interface/api/46138) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/change/dialogue/config`
 * @更新时间 `2023-12-13 10:08:34`
 */
export const feimaChatCustomerChangeDialogueConfig = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerChangeDialogueConfigRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatCustomerChangeDialogueConfigResponse,
      OT
    >
  >('/customer/change/dialogue/config', 'POST', data, options);

/**
 * 接口 [获取客户对话配置↗](https://yapi.fenxianglife.com/project/379/interface/api/46144) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/get/dialogue/config`
 * @更新时间 `2023-11-21 13:59:49`
 */
export const feimaChatCustomerGetDialogueConfig = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerGetDialogueConfigRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatCustomerGetDialogueConfigResponse,
      OT
    >
  >('/customer/get/dialogue/config', 'POST', data, options);

/**
 * 接口 [客户列表V2↗](https://yapi.fenxianglife.com/project/379/interface/api/48120) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/v2/list`
 * @更新时间 `2024-03-18 11:29:04`
 */
export const feimaChatCustomerV2List = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerV2ListRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatCustomerV2ListResponse, OT>>(
    '/customer/v2/list',
    'POST',
    data,
    options
  );

/**
 * 接口 [新增扩展表头↗](https://yapi.fenxianglife.com/project/379/interface/api/48136) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/extraTable/header/add`
 * @更新时间 `2024-03-14 17:30:09`
 */
export const feimaChatCustomerExtraTableHeaderAdd = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerExtraTableHeaderAddRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatCustomerExtraTableHeaderAddResponse,
      OT
    >
  >('/customer/extraTable/header/add', 'POST', data, options);

/**
 * 接口 [修改扩展表头↗](https://yapi.fenxianglife.com/project/379/interface/api/48144) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/extraTable/header/modify`
 * @更新时间 `2024-03-14 17:30:24`
 */
export const feimaChatCustomerExtraTableHeaderModify = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerExtraTableHeaderModifyRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatCustomerExtraTableHeaderModifyResponse,
      OT
    >
  >('/customer/extraTable/header/modify', 'POST', data, options);

/**
 * 接口 [删除扩展表头↗](https://yapi.fenxianglife.com/project/379/interface/api/48152) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/extraTable/header/delete`
 * @更新时间 `2024-03-14 17:30:34`
 */
export const feimaChatCustomerExtraTableHeaderDelete = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerExtraTableHeaderDeleteRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatCustomerExtraTableHeaderDeleteResponse,
      OT
    >
  >('/customer/extraTable/header/delete', 'POST', data, options);

/**
 * 接口 [编辑客户扩展信息↗](https://yapi.fenxianglife.com/project/379/interface/api/48160) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/extraTable/info/edit`
 * @更新时间 `2024-03-14 17:39:12`
 */
export const feimaChatCustomerExtraTableInfoEdit = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerExtraTableInfoEditRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatCustomerExtraTableInfoEditResponse,
      OT
    >
  >('/customer/extraTable/info/edit', 'POST', data, options);

/**
 * 接口 [添加准许名单↗](https://yapi.fenxianglife.com/project/379/interface/api/48192) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/permit/add`
 * @更新时间 `2024-03-15 16:04:31`
 */
export const feimaChatCustomerPermitAdd = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerPermitAddRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatCustomerPermitAddResponse, OT>
  >('/customer/permit/add', 'POST', data, options);

/**
 * 接口 [查询扩展表头↗](https://yapi.fenxianglife.com/project/379/interface/api/48208) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/extraTable/header/list`
 * @更新时间 `2024-03-15 15:39:15`
 */
export const feimaChatCustomerExtraTableHeaderList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data?: ToolTypes.GetRequestType<API.FeimaChatCustomerExtraTableHeaderListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatCustomerExtraTableHeaderListResponse,
      OT
    >
  >('/customer/extraTable/header/list', 'POST', data, options);

/**
 * 接口 [添加好友任务列表↗](https://yapi.fenxianglife.com/project/379/interface/api/48784) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/addTask/list`
 * @更新时间 `2024-03-26 16:05:39`
 */
export const feimaChatCustomerAddTaskList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerAddTaskListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatCustomerAddTaskListResponse, OT>
  >('/customer/addTask/list', 'POST', data, options);

/**
 * 接口 [获取添加好友任务配置↗](https://yapi.fenxianglife.com/project/379/interface/api/48792) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `GET /customer/addTask/config`
 * @更新时间 `2024-03-22 17:54:23`
 */
export const feimaChatCustomerAddTaskConfig = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerAddTaskConfigRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatCustomerAddTaskConfigResponse, OT>
  >('/customer/addTask/config', 'GET', data, options);

/**
 * 接口 [修改添加好友任务配置↗](https://yapi.fenxianglife.com/project/379/interface/api/48808) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/addTask/config/edit`
 * @更新时间 `2024-03-25 14:28:55`
 */
export const feimaChatCustomerAddTaskConfigEdit = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerAddTaskConfigEditRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatCustomerAddTaskConfigEditResponse,
      OT
    >
  >('/customer/addTask/config/edit', 'POST', data, options);

/**
 * 接口 [通过Excel添加任务↗](https://yapi.fenxianglife.com/project/379/interface/api/48816) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/addTask/create/excel`
 * @更新时间 `2024-03-22 18:00:48`
 */
export const feimaChatCustomerAddTaskCreateExcel = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerAddTaskCreateExcelRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatCustomerAddTaskCreateExcelResponse,
      OT
    >
  >('/customer/addTask/create/excel', 'POST', data, options);

/**
 * 接口 [手动添加任务↗](https://yapi.fenxianglife.com/project/379/interface/api/48824) 的 **请求函数**
 *
 * @分类 [客户相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10325)
 * @请求头 `POST /customer/addTask/create/manual`
 * @更新时间 `2024-03-26 11:08:42`
 */
export const feimaChatCustomerAddTaskCreateManual = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerAddTaskCreateManualRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatCustomerAddTaskCreateManualResponse,
      OT
    >
  >('/customer/addTask/create/manual', 'POST', data, options);

/**
 * 接口 [提交表单↗](https://yapi.fenxianglife.com/project/379/interface/api/47434) 的 **请求函数**
 *
 * @分类 [客户联系↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10769)
 * @请求头 `POST /customer/contact/submit`
 * @更新时间 `2024-01-02 09:48:19`
 */
export const feimaChatCustomerContactSubmit = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatCustomerContactSubmitRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatCustomerContactSubmitResponse, OT>
  >('/customer/contact/submit', 'POST', data, options);

/* prettier-ignore-end */
